module.exports = __webpack_public_path__ + "img/culture_1_mobile.6de5efab.png";